import {observable} from 'mobx';

class MergeFieldViewModel {
  @observable name;
  @observable key;
  @observable annotationType;
  @observable alreadyTranslated;

  constructor({name, key, annotationType, alreadyTranslated}) {
    this.name = name;
    this.key = key;
    this.annotationType = annotationType;
    this.alreadyTranslated = alreadyTranslated;
  }

  static fromHash({key, name, annotationType, alreadyTranslated = false}) {
    return new MergeFieldViewModel({
      name,
      key,
      alreadyTranslated,
      annotationType: annotationType || 'variable'
    });
  }
}

export default MergeFieldViewModel;
